import { useEffect } from "react";
import CardTestimoMarcas from "./CardTestimoMarcas";
import CardTestimoClientes from "./CardTestimoClientes";
import CardClientes from "./cardClientes";
import useStore from "../store/useStore";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";

export default function CarouselTestimonios() {
  const { testimonioMarcas, getTestimonioMarcas } = useStore();
  const { testimonioUser, getTestimonioUSer } = useStore();
  const { testimonioclientes, fetchTestimonioById } = useStore();

  useEffect(() => {
    getTestimonioMarcas();
    getTestimonioUSer();
    fetchTestimonioById();
  }, [getTestimonioMarcas, getTestimonioUSer, fetchTestimonioById]);

  const allTestimonials = [
    ...testimonioclientes,
    ...testimonioMarcas,
    ...testimonioUser,
  ];

  function shuffle(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  const randomizedTestimonials = shuffle(allTestimonials);
  const mitad = Math.ceil(randomizedTestimonials.length / 2);
  const primerCarrusel = randomizedTestimonials.slice(0, mitad);
  const idsPrimerCarrusel = new Set(primerCarrusel.map((t) => t.id));
  const segundoCarrusel = randomizedTestimonials.filter(
    (t) => !idsPrimerCarrusel.has(t.id)
  );

  const breakpoints = {
    0: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
    420: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 1.2, spaceBetween: 30 },
    768: { slidesPerView: 1.5, spaceBetween: 30 },
    1024: { slidesPerView: 2, spaceBetween: 40 },
    1200: { slidesPerView: 3, spaceBetween: 30 },
    1600: { slidesPerView: 3, spaceBetween: 40 },
    2000: { slidesPerView: 4, spaceBetween: 40 },
  };

  return (
    <div>
      <div className="container relative text-left mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[60px]">
        <h1 className="font-extrabold text-left text-3xl md:text-[40px] lg:text-[45px] px-2 md:px-0 lg:px-0 leading-tight text-sidom-orange mb-8">
          Experiencias SIDOM
        </h1>
      </div>

      {/* PRIMER CARRUSEL */}
      <div className="relative container mb-[30px]">
        {primerCarrusel.length > 0 && (
          <>
            <Swiper
              spaceBetween={30}
              speed={8000}
              autoplay={{
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: true,
              }}
              centeredSlides={true}
              initialSlide={Math.floor(primerCarrusel.length / 2)}
              onSwiper={(swiper) =>
                swiper.slideTo(Math.floor(primerCarrusel.length / 2), 0)
              }
              navigation={{
                prevEl: ".swiper-button-prev-custom  ",
                nextEl: ".swiper-button-next-custom ",
              }}
              modules={[Autoplay, Pagination, Navigation]}
              breakpoints={breakpoints}
              className="mySwiper"
            >
              {primerCarrusel
                .filter((item) => item && item.Tipo)
                .map((item, idx) => {
                  const key = `${item.Tipo || "tipo"}-${item.id || idx}`;
                  switch (item.Tipo) {
                    case "Testimonio":
                      return (
                        <SwiperSlide key={key}>
                          <CardClientes
                            image={item.img?.formats?.thumbnail?.url}
                            name={item.nombre}
                            title={item.cargo}
                            desc={item.comentario}
                            rating={item.estrellas}
                          />
                        </SwiperSlide>
                      );
                    case "Testimoniomarcas":
                      return (
                        <SwiperSlide key={key}>
                          <CardTestimoMarcas
                            title={item.empresa || item.title}
                            title2={item.titulo || item.title2}
                            description={item.comentario || item.description}
                            buttonText="Ver Caso Completo"
                            url={item.url || ""}
                          />
                        </SwiperSlide>
                      );
                    case "testimoniouser":
                      return (
                        <SwiperSlide key={key}>
                          <CardTestimoClientes
                            title={item.nombre}
                            title2={item.cargo}
                            description={item.comentario}
                            image={item.img?.formats?.thumbnail?.url}
                            buttonText="Ver VIDEO"
                            youtubeUrl="https://www.youtube.com/embed/J9oATQIj1Tg?si=Y9pFfs_A6eY330j1"
                          />
                        </SwiperSlide>
                      );
                    default:
                      return null;
                  }
                })}
            </Swiper>

            {/* Flechas pequeñas y mejor posicionadas */}
            <button className="swiper-button-prev-custom absolute -left-1 top-[60%] -translate-y-1/2 z-50 p-1 lg:p-3 hover:opacity-75 transition-all duration-300">
              <img src={imgI} alt="Flecha izquierda" className="w-5 " />
            </button>
            <button className="swiper-button-next-custom absolute -right-1 top-[60%] -translate-y-1/2 z-50 p-1 lg:p-3 hover:opacity-75 transition-all duration-300">
              <img src={imgD} alt="Flecha derecha" className="w-5 " />
            </button>
          </>
        )}
      </div>

      {/* SEGUNDO CARRUSEL */}
      <div className="relative container">
        {segundoCarrusel.length > 0 && (
          <>
            <Swiper
              speed={8000}
              autoplay={{
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: false,
              }}
              centeredSlides={true}
              initialSlide={Math.floor(segundoCarrusel.length / 2)}
              onSwiper={(swiper) =>
                swiper.slideTo(Math.floor(segundoCarrusel.length / 2), 0)
              }
              navigation={{
                prevEl: ".swiper-button-prev-custom",
                nextEl: ".swiper-button-next-custom",
              }}
              modules={[Autoplay, Pagination, Navigation]}
              breakpoints={breakpoints}
              className="mySwiper"
            >
              {segundoCarrusel
                .filter((item) => item && item.Tipo)
                .map((item, idx) => {
                  const key = `${item.Tipo || "tipo"}-${item.id || idx}`;
                  switch (item.Tipo) {
                    case "Testimonio":
                      return (
                        <SwiperSlide key={key}>
                          <CardClientes
                            image={item.img?.formats?.thumbnail?.url}
                            name={item.nombre}
                            title={item.cargo}
                            desc={item.comentario}
                            rating={item.estrellas}
                          />
                        </SwiperSlide>
                      );
                    case "Testimoniomarcas":
                      return (
                        <SwiperSlide key={key}>
                          <CardTestimoMarcas
                            title={item.empresa || item.title}
                            title2={item.titulo || item.title2}
                            description={item.comentario || item.description}
                            buttonText="Ver Caso Completo"
                            url={item.url || ""}
                          />
                        </SwiperSlide>
                      );
                    case "testimoniouser":
                      return (
                        <SwiperSlide key={key}>
                          <CardTestimoClientes
                            title={item.nombre}
                            title2={item.cargo}
                            description={item.comentario}
                            image={item.img?.formats?.thumbnail?.url}
                            buttonText="Ver VIDEO"
                            youtubeUrl={item.url}
                          />
                        </SwiperSlide>
                      );
                    default:
                      return null;
                  }
                })}
            </Swiper>

            {/* Flechas del segundo carrusel */}
            <button className="swiper-button-prev-custom absolute -left-1 top-[60%] -translate-y-1/2 z-30 p-1 lg:p-3 hover:opacity-75 transition-all duration-300">
              <img src={imgI} alt="Flecha izquierda" className="w-5" />
            </button>
            <button className="swiper-button-next-custom absolute -right-1 top-[60%] -translate-y-1/2 z-30 p-1 lg:p-3 hover:opacity-75 transition-all duration-300">
              <img src={imgD} alt="Flecha derecha" className="w-5" />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
